import React, { Fragment } from 'react';
import { Button, Checkbox, Dropdown, Grid, Icon } from 'semantic-ui-react';
import DataGrid from '../shared/DataGrid';
import DownloadButton from '../shared/DownloadButton';
import collections from '../../api/collections';
import { handleDownload } from '../../helpers/downloads';
import CollectionFilters from './CollectionFilters';
import DetailsButton from '../shared/DetailsButton';

class BaseCollection extends React.Component {

  state = {
    loading: false,
    loadingReport: false,
    loadingExport: false,
    currentWeek: true,
    row: null,
    from: null,
    to: null,
    periods: [],
    grid: {
      data: [],
      headerDef: [],
      rowDef: []
    },
    activeRow: {
      optionShowDetails: false
    }
  };

  handleDownload = () => {
    const { from, currentWeek, periods } = this.state;
    if (periods.length) {
      const to  = currentWeek ? "-1" : this.state.to;
      const { siteId, operator } = this.props;

      this.setState({ loadingExport: true }, () => {
        this.fnGetExport(operator, siteId, from, to).then(
          response => {
            this.setState({ loadingExport: false}, () => {
              handleDownload(this.exportFileName, response)
            })
          },
          () => this.setState({ loadingExport: false })
        );
      })
    }
  }

  onDetailsClick = async () => {
    const { activeRow } = this.state;

    this.setState({ loading: true }, () => {
      const { siteId, operator } = this.props;
      const { periodId } = activeRow;

      this.fnRowClick(operator, siteId, periodId).then(
        result => {
          this.setState({ loading: false }, () => {
            this.props.showCollectionModal(
              true, 
              { operator, siteId, periodId, ...result },
              this.modalTitle,
              async () => {
                await this.onDetailsClick()
              },
              () => this.handleRefresh()
            );
          })
        },
        () => this.setState({ loading: false })
      )
    })
  }

  onRowClick = (activeRow) => this.setState({ activeRow })

  handleRefresh = () => {
    const { from, currentWeek, periods } = this.state;
    if (periods.length) {
      const to  = currentWeek ? "-1" : this.state.to;
      const { siteId, operator } = this.props;

      this.setState({ loading: true }, () => {
        this.fnRefresh(operator, siteId, from, to).then(
          result => {
            this.setState({ loading: false, grid: result.grid }, () => {
                if (!this.state.grid.data.includes(this.state.activeRow))
                  this.setState({ activeRow: { optionShowDetails: false }})
            })
          },
          () => this.setState({ loading: false })
        );
      })
    }
  }

  componentDidMount() {
    this.loadPeriods();
  }

  loadPeriods = () => {
    const { siteId, operator } = this.props;
    this.setState({
      loading: true,
      grid: {
        data: [],
        headerDef: [],
        rowDef: []
      },
      periods: []
    }, () => {
      this.setState({ loading: false }, () => {
        if (siteId) {
          this.setState({ loading: true }, () => {
            collections.getPeriods(operator, siteId).then(
              periods => {
                const defaultPeriod = periods.find(period => period.isDefault) || periods[0];
                this.setState({ periods, from: defaultPeriod ? defaultPeriod.value : null, loading: false }, () => {
                  if (periods.length > 0) this.handleRefresh();
                })
              }
            );
          })
        }
      })
    });
  }

  componentDidUpdate(prevProps) {
    if ((this.props.siteId !== prevProps.siteId || this.props.operator !== prevProps.operator)) {
      this.loadPeriods();
    }
  }

  setCurrentWeek = () => this.setState({ currentWeek: !this.state.currentWeek})

  handleVarianceHistory = () => {
    this.props.showSiteVarianceHistoryModal(true);
  }

  onChange = (event, { name, value }) => this.setState({ [name]: value })

  handlePdfClick = (downloadFn = async () => {}, fileName) => {
    const { activeRow } = this.state;
    if (activeRow.batchId) {
      this.setState({ loadingReport: true }, () => {
        downloadFn(activeRow.batchId).then(
          response => this.setState({ loadingReport: false }, () => handleDownload(fileName, response)),
          () => this.setState({ loadingReport: false })
        )
      })
    }
  }

  render() {
    const { headerDef, rowDef, data } = this.state.grid;
    const { loadingExport } = this.state;

    return (
      <Grid className="height-100 gs-flex-container-vertical">
        <Grid.Row>
          <Grid.Column width="12">
            <CollectionFilters 
              {...this.state}
              onChange={this.onChange}
              onChangeCurrentWeek={this.setCurrentWeek}
              onVarianceClick={this.handleVarianceHistory}
              onRefreshClick={this.handleRefresh}
              onExportClick={this.handleDownload}
              loadingExport={loadingExport}
              showVarianceHistory={this.props.showVarianceHistory}
            />
          </Grid.Column>
          <Grid.Column textAlign="right" width="4">
            { this.state.activeRow.optionShowDetails && <DetailsButton onClick={this.onDetailsClick} /> }
            {(this.state.activeRow.batchId && this.fnGetSummaryPdf !== null) &&
              <Dropdown 
                direction="left"
                icon={null}
                floated="right"
                trigger={<Button color="teal" loading={this.state.loadingReport} icon labelPosition="right"><Icon name="caret down" /> Reports</Button>} 
              >
                <Dropdown.Menu>
                  <Dropdown.Item text={this.reportName} onClick={() => this.handlePdfClick(this.fnGetSummaryPdf, `${this.reportFileName} Report`)} />
                  <Dropdown.Item text='Collection Variance PDF' onClick={() => this.handlePdfClick(this.fnGetVariancePdf, "Collection Variance Report")} />
                  <Dropdown.Item text='Machine Performance PDF' onClick={() => this.handlePdfClick(collections.getMachinePerformancePdf, "Machine Performance Analysis Report")} />
                  <Dropdown.Item text='Machine Performance CSV' onClick={() => this.handlePdfClick(collections.getMachinePerformanceCsv, "Machine Performance Analysis Report")} />
                </Dropdown.Menu>
              </Dropdown>
            }
         </Grid.Column>
        </Grid.Row>
        <Grid.Row className="flex-stretch">
          <Grid.Column width="16" className="gs-flex-container-vertical">
            <DataGrid
              loading={this.state.loading}
              headings={headerDef}
              data={data}
              activeRow={this.state.activeRow}
              rowDef={rowDef}
              onRowClick={this.onRowClick}
              fullHeight
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default BaseCollection;

